import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import failedImg from '../../../assets/images/error.svg'
import Button from '../../../components/Button'
import { COUNTRY } from '../../../const/constants'
import { useAppContext } from '../../../context/AppContext'
import { useStepsContext } from '../../../context/StepsContext'
import { procedureComplete } from '../../../redux/actions'

const PortabilidadFailed = () => {
  const { setBlockNavigation, settings }: any = useAppContext()
  const history = useHistory()

  const dispatch = useDispatch()
  const { resetSteps }: any = useStepsContext()

  const onContinue = () => {
    dispatch(procedureComplete())
    resetSteps()
    history.push('/procedures/portabilidades')
    setBlockNavigation(false)
  }

  return (
    <main className="landing">
      <div className="landing-container">
        <img src={failedImg} alt="portability failed" style={{ height: '150px' }} />
        <h4>
          <strong id="nueva-portabilidad-strong-failed">Algo salió mal</strong> <br />
          <strong id="nueva-portabilidad-strong-failed">La portabilidad no pudo realizarse</strong>
        </h4>
        <p className="error-sugest">
          Por favor, ingresá más tarde a la pestaña
          <br />
          <strong>&quot;A completar&quot;</strong> y finalizá el trámite.
        </p>
        {settings.country === COUNTRY.PY && (
          <p className="error-sugest">
            Si el problema persiste reportá el <br />
            caso enviando un sms al 7767 desde <br />
            cualquier línea Claro o al 0994 401 111.
          </p>
        )}
        <Button
          id="portability-failed-back-to-start"
          label="Ir al inicio"
          landing
          className="link-button"
          handleSubmit={onContinue}
        />
      </div>
    </main>
  )
}

export default PortabilidadFailed
